import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './CaseTakeOver.module.scss';
import { useAssignCaseToMeMutation } from '../../../../graphql/graphql';
import { markCaseForPatientAutoVerify } from '../../../Nczi/Services/patientAutoVerify.service';

interface Props {
	caseId: string;
}

const validationSchema = yup.object({
	message: yup.string().notRequired(),
});

const CaseTakeOver: React.FC<Props> = ({ caseId }) => {
	const [assignCaseToMe] = useAssignCaseToMeMutation();
	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		const response = await assignCaseToMe({
			input: {
				caseId,
				message: values?.message,
			},
		}).unwrap();
		if (response) {
			markCaseForPatientAutoVerify(caseId);
			// @ts-ignore
			window.location.href = '/ordinace/detail/' + caseId;
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<TextAreaField
				name='message'
				label='component.caseTakeOver.message'
				isWrapped
			/>
			<div className={styles.wrapper}>
				<SubmitButton
					onSubmit={handleSubmit}
					title='component.caseTakeOver.yesTakeOverCase'
				/>
				<LinkButton title='component.caseTakeOver.cancel' theme={Theme.RED} />
			</div>
		</FormWrapper>
	);
};

export default CaseTakeOver;
